/**
 * Изображения, плавно появляющиеся при загрузке
 */
export class FadeInImage {
    constructor(el) {
        this.img = el;
        this.init();
    }

    init() {
        const bg = this.img.matches('[style]');
        const imgLoad = new imagesLoaded(this.img, { background: bg });

        imgLoad.on('always', () => {
            this.img.classList.add('_is-loaded');
        });
    }
}

document.querySelectorAll('[data-fadein]').forEach(el => {
    new FadeInImage(el);
});



// WEBPACK FOOTER //
// ./_src/js/FadeinImage.js